import { PropsWithChildren, ReactNode } from "react";

import { FeatureToggleKey } from "./feature-toggles";
import { useFeatureToggles } from "./use-feature-toggles";

type Props = PropsWithChildren<{
  feature: FeatureToggleKey;
  not?: boolean;
}>;

export const FeatureToggle = ({ feature: featureKey, not = false, children }: Props): ReactNode => {
  const { enabled: featureToggleValue } = useFeatureToggles(featureKey);
  const isFeatureEnabled = not ? !featureToggleValue : featureToggleValue;

  if (!isFeatureEnabled) {
    return null;
  }
  return <>{children}</>;
};
